import React from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
import { useSessionTimer } from '../hooks/useSessionTimer';

export const SessionTimer: React.FC = () => {
  const { isVisible, formattedTime, isLoggedIn } = useSessionTimer();

  if (!isLoggedIn || !isVisible) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 bg-red-100 border-2 border-red-300 rounded-lg p-3 shadow-lg animate-pulse">
      <div className="flex items-center space-x-2 text-red-700">
        <AlertTriangle className="w-5 h-5" />
        <Clock className="w-4 h-4" />
        <span className="font-semibold text-sm">
          Detectando inatividade: {formattedTime} restante(s)
        </span>
      </div>
    </div>
  );
};